import { render, staticRenderFns } from "./ComponentResolver.vue?vue&type=template&id=33fb98cc"
import script from "./ComponentResolver.js?vue&type=script&lang=js&external"
export * from "./ComponentResolver.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports